import { useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import AddToPortfolio from "@components/Forms/AddToPortfolio";

import useRemoveContacts from "@hooks/useRemoveContacts";

import { ContactType } from "@interfaces/contact.type";

import { useAddContactToTechnology, useCreateTechnologyFromContactIdsQuery } from "@queries/portfolio.query";

import ContactService from "@services/contact.service";

import { PopupActions } from "@store/popupStore";
import { useUserStore } from "@store/userStore";

interface IContactsTableToolbar {
  contacts: ContactType[];
  searchId?: string;
  selectedIds: string[];
  technologyName?: string;
  workflow: string;
}

const useContactsTableToolbar = ({ contacts, selectedIds, technologyName, workflow }: IContactsTableToolbar) => {
  const user = useUserStore();
  const parameters = useParams();
  const technologyId = parameters.technologyId;
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const searchId = user.currentSearch ?? "";

  const toggleFilters = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const { mutateAsync: createTechnologyFromContactIds } = useCreateTechnologyFromContactIdsQuery();
  const { mutateAsync: addContactsToTechnology } = useAddContactToTechnology();

  //TODO: come up with better solution for this on refactor
  const location = useLocation();

  const isContactResultsPage = location.pathname.includes("contact-results");

  const isSmartSearch = location.pathname.includes("smart-search");

  const handleExportContacts = () => {
    void ContactService.exportContacts(selectedIds, contacts);
  };

  const removeContacts = useRemoveContacts();

  const handleAddContactsToTechnology = () => {
    PopupActions.openModal({
      content: (
        <AddToPortfolio
          addToTechnology={async (technologyId, technologyName) => {
            await addContactsToTechnology({
              contactIds: selectedIds,
              searchId,
              technologyId,
              technologyName,
            });
            PopupActions.closeModal();
          }}
          createTechnology={async (name, description) => {
            await createTechnologyFromContactIds({
              contactIds: selectedIds,
              description: isSmartSearch ? description : "",
              name,
              searchId,
            });
            PopupActions.closeModal();
          }}
        />
      ),
      title: "Save to Technology",
    });
  };

  const handleRemoveContacts = () => {
    if (!technologyName || !technologyId) return;

    void removeContacts({
      contactIds: selectedIds,
      technologyId,
      technologyName,
    });
  };

  return {
    handleAddContactsToTechnology,
    handleExportContacts,
    handleRemoveContacts,
    isContactResultsPage,
    isFilterOpen,
    isSmartSearch,
    removeContacts,
    toggleFilters,
  };
};

export default useContactsTableToolbar;
